export const translations = {
  insurerName: "Nombre",
  description: "Descripcion",
  logo: "Logo",
};
